export default {
    'bond-no': 'Bond No.',
    add: 'Add',
    delete: 'Delete',
    'bond-date': 'Bond date',
    'create-bond': 'Add bond',
    edit: 'Edit',
    save: 'Save',

    not: 'Non',
    posted: 'Posted',

    'total-costs': 'Total costs: ',
    'create-manufacturing-bond': 'Add manufacturing bond',
    'manufacturing-bond-date': 'Manufacturing bond date',
    
    create: 'Create',
    cancel: 'Cancel',

    'delete-entry': 'Delete item',
    'are-you-sure-you-want-to-delete-the-entry': 'Do you want to delete this item?',

    'delete-journal': 'Delete journal',
    'are-you-sure-you-want-to-delete-the-journal': 'Do you want to delete this journal?',

    'context-menu': {
        'show-details': 'Show details',
        edit: 'Edit',
        delete: 'Delete',
    },

    headers: {
        'no': 'Serial',
        'warehouse': 'Warehouse',
        'material-name': 'Item name',
        'count': 'Count',
        'produced-quantity': 'Produced quantity',
        'unit': 'Unit',
        'loss-ratio': 'Impairment Percent',
        'cost-of-one': 'Unit Cost',
        'total-cost': 'Total cost',
    },
}